<div class="modal-header">
  <h6 class="modal-title pull-left"> {{updateId==''?'Assign':'Edit' }} Role to User</h6>
  <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-6 col-sm-12">
      <div class="form-group">
        <label for="ID">Event</label>
        <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.org_ref_id"
          (ngModelChange)="onOrgChange($event,addUserObj.day)">
          <ng-option value="" disabled="true">Select Event</ng-option>
          <ng-option *ngFor="let event of orgList; let i = index" [value]="event.id">{{ event.org_name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="form-group">
        <label for="ID">Day</label>
        <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.day"
          (ngModelChange)="onDayChange($event)">
          <ng-option value="" disabled="true">Select Day</ng-option>
          <ng-option [value]="1">Day 1</ng-option>
          <ng-option [value]="2">Day 2</ng-option>
          <ng-option [value]="3">Day 3</ng-option>
        </ng-select>
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="form-group">
        <label for="ID">Date</label> <br>
        <input class="form-control divide" [readOnly]="true" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="date"
          ngbDatepicker #d="ngbDatepicker" (ngModelChange)="dateChange()">
      </div>
    </div>
   
    <div class="col-md-6 col-sm-12">
      <div class="form-group">
        <label for="ID">Role</label>
        <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.user_role"
          (ngModelChange)="onRoleChange($event)">
          <ng-option value="" disabled="true">Select Role</ng-option>
          <ng-option value="1">Speaker </ng-option>
          <ng-option value="2">Delegate </ng-option>
          <ng-option value="3">AFGG</ng-option>
        </ng-select>
      </div>
    </div>
 
    <div class="col-md-12 col-sm-12">
      <div class="form-group">
        <label for="ID">User</label>
        <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.user_ref_id"
          (ngModelChange)="onUserChange($event)">
          <ng-option value="" disabled="true">Select User</ng-option>
          <ng-option *ngFor="let user of userList; let i = index" [value]="user.id">{{ user.user_name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <section class="mb10">
      <div class="row mb10">
        <div class="col-md-3 col-sm-3">
          <div class="form-check">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck1"
                [(ngModel)]="addUserObj.breakfast_valid">
              <label class="custom-control-label" for="customCheck1">Breakfast</label>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="form-check">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck2"
                [(ngModel)]="addUserObj.lunch_valid">
              <label class="custom-control-label" for="customCheck2">Lunch</label>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="form-check">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck4" [(ngModel)]="addUserObj.tea_valid">
              <label class="custom-control-label" for="customCheck4">Conversations over Kahwa</label>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="form-check">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheck3"
                [(ngModel)]="addUserObj.dinner_valid">
              <label class="custom-control-label" for="customCheck3">Dinner</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-3">
          <div class="form-group" *ngIf="addUserObj.breakfast_valid!=''">
            <label for="ID">Gate</label>
            <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.breakfast_gate" [multiple]="true"
              (ngModelChange)="onBreakfastChange($event)">
              <ng-option value="" disabled="true">Select Gate</ng-option>
              <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="form-group" *ngIf="addUserObj.lunch_valid!=''">
            <label for="ID">Gate</label>
            <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.lunch_gate" [multiple]="true"
              (ngModelChange)="onLunchChange($event)">
              <ng-option value="" disabled="true">Select Gate</ng-option>
              <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name }}
              </ng-option>
            </ng-select>
          </div>
        </div>

        <div class="col-md-3 col-sm-3">
          <div class="form-group" *ngIf="addUserObj.tea_valid!=''">
            <label for="ID">Gate</label>
            <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.tea_gate" [multiple]="true"
              (ngModelChange)="onTeaChange($event)">
              <ng-option value="" disabled="true">Select Gate</ng-option>
              <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="form-group" *ngIf="addUserObj.dinner_valid!=''">
            <label for="ID">Gate</label>
            <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.dinner_gate" [multiple]="true"
              (ngModelChange)="onDinnerChange($event)">
              <ng-option value="" disabled="true">Select Gate</ng-option>
              <ng-option *ngFor="let gate of gateList; let i = index" [value]="gate.id">{{ gate.gate_name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div #agenda class="row">
    <div class="col-md-12 col-sm-12">
      <div class="form-group">
        <label for="qustion">Agenda</label>
        <angular-editor id="editor1" placeholder="Agenda" [(ngModel)]="addUserObj.agenda"
          [config]="config"></angular-editor>
      </div>
    </div>
    <div *ngIf="this.addUserObj.user_role=='1'" class="col-md-12 col-sm-12">
      <div class="form-group">
        <label for="qustion">Speaking Engagement</label>
        <angular-editor id="editor2" placeholder="Speaking Engagement" [(ngModel)]="addUserObj.speaking_engagement"
          [config]="config"></angular-editor>

        <!-- <textarea class="form-control" rows="3" placeholder="Speaking Engagement"
                    [(ngModel)]="addUserObj.speaking_engagement"></textarea> -->
      </div>
    </div>
    <div class="col-md-12 col-sm-12">
      <div class="form-group">
        <label for="qustion">Dining Invite</label>
        <angular-editor id="editor3" placeholder="Dining Invite" [(ngModel)]="addUserObj.dinning"
          [config]="config"></angular-editor>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
  <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>